import { useState } from "react";
import type { ReactNode } from "react";
import { useAuth } from "../lib/auth-context";
import { Icon, IconSprite } from "./Icons";
import { Sidebar } from "./Sidebar";

interface Props {
  children: ReactNode;
  showHeader?: boolean;
}

export function Shell({ children, showHeader = true }: Props) {
  const { user } = useAuth();
  const now = new Date();
  const fecha = now.toLocaleDateString("es-CO", {
    timeZone: "America/Bogota",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
  const hora = now.toLocaleTimeString("en-US", {
    timeZone: "America/Bogota",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
  const stamp = `${fecha} ${hora}`;
  const [drawerOpen, setDrawerOpen] = useState(false);

  const showSidebar = showHeader && Boolean(user);

  const stripBlock = (
    <div className="strip">
      <div className="strip-inner">
        <span className="flag-co" aria-hidden />
        <span>República de Colombia · Plataforma de atención ciudadana</span>
        <span className="spacer" />
        <span>v0.1 · {stamp}</span>
      </div>
    </div>
  );

  if (!showSidebar) {
    return (
      <>
        <a href="#main" className="skip-link">
          Saltar al contenido
        </a>
        <IconSprite />
        {stripBlock}
        <main id="main" tabIndex={-1}>
          {children}
        </main>
      </>
    );
  }

  return (
    <>
      <a href="#main" className="skip-link">
        Saltar al contenido
      </a>
      <IconSprite />
      <div className="app-shell app-shell-collapsed">
        <div className="sidebar-slot">
          <Sidebar />
        </div>

        <div className="app-main-col">
          <div className="mobile-topbar">
            <button
              type="button"
              className="hamburger"
              onClick={() => setDrawerOpen(true)}
              aria-label="Abrir menú"
            >
              <Icon id="mi-menu" size={20} />
            </button>
            <div className="mobile-brand">
              MiPueblo <span className="dot" aria-hidden /> Panel
            </div>
          </div>

          {stripBlock}

          <main className="app-main" id="main" tabIndex={-1}>
            {children}
          </main>
        </div>

        {drawerOpen && (
          <div
            className="drawer-backdrop"
            onClick={() => setDrawerOpen(false)}
            role="presentation"
          >
            <div className="drawer-panel" onClick={(e) => e.stopPropagation()}>
              <Sidebar onClose={() => setDrawerOpen(false)} />
            </div>
          </div>
        )}
      </div>
    </>
  );
}
